import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Redirect, Route, Router as BaseRouter, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import ContentDetail from "./pages/ContentDetail";
import { AboutPage, ContactPage, PolicyPage, PortalPage, ProjectsPage, ResearchPage, TechnologyPage } from "./pages/CorporatePages";
import { InsightArticlePage, InsightsHub } from "./pages/InsightPages";
import { allPublicPages, insights, legacySolutionRedirects } from "@shared/siteContent";
import { RouteEffects } from "./components/RouteEffects";
import { Head } from "./components/Head";
import { LocaleProvider, useLocale } from "./contexts/LocaleContext";

function Router() {
  // make sure to consider if you need authentication for certain routes
  return (
    <Switch>
      <Route path={"/"} component={Home} />
      {Object.entries(legacySolutionRedirects).map(([from, to]) => <Route key={from} path={from}>{() => <Redirect to={to} />}</Route>)}
      {allPublicPages.map((page) => <Route key={page.path} path={page.path}>{() => <ContentDetail page={page} />}</Route>)}
      <Route path="/technology" component={TechnologyPage} />
      <Route path="/projects" component={ProjectsPage} />
      <Route path="/insights" component={InsightsHub} />
      {insights.map((article) => <Route key={article.path} path={article.path}>{() => <InsightArticlePage article={article} />}</Route>)}
      <Route path="/about" component={AboutPage} />
      <Route path="/beyond-todays-maps" component={ResearchPage} />
      <Route path="/contact" component={ContactPage} />
      <Route path="/privacy">{() => <PolicyPage kind="Privacy Policy" />}</Route>
      <Route path="/terms">{() => <PolicyPage kind="Terms of Use" />}</Route>
      <Route path="/cookies">{() => <PolicyPage kind="Cookie Policy" />}</Route>
      <Route path="/portal" component={PortalPage} />
      <Route path={"/404"} component={NotFound} />
      {/* Final fallback route */}
      <Route component={NotFound} />
    </Switch>
  );
}

// NOTE: About Theme
// - First choose a default theme according to your design style (dark or light bg), than change color palette in index.css
//   to keep consistent foreground/background color across components
// - If you want to make theme switchable, pass `switchable` ThemeProvider and use `useTheme` hook

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider
        defaultTheme="dark"
        // switchable
      >
        <LocaleProvider><LocaleApplication /></LocaleProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

function LocaleApplication() {
  const { locale } = useLocale();
  return <BaseRouter base={locale === "ar" ? "/ar" : undefined}><TooltipProvider><Head /><RouteEffects /><Toaster /><Router /></TooltipProvider></BaseRouter>;
}

export default App;
